export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["过滤器"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["方向"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易金额"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["交易ID"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["操作类型"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["参数"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["商户操作ID"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["账户"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["应用"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["清除全部"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["入站 / 出站"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择状态"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择金额类型"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入金额"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入ID"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择类型"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["输入参数"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["选择密钥"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["按额外交易参数搜索，如卡号、钱包地址、电话号码等。"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["清除"])}
}